module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/neutralIcon.74d21562.svg";